import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const FilterControls = ({ filters, onFilterChange }) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'success', label: 'Success' },
    { value: 'error', label: 'Error' },
    { value: 'pending', label: 'Pending' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' }
  ];

  const handleStatusChange = (value) => {
    onFilterChange({ ...filters, status: value });
  };

  const handleDateRangeChange = (value) => {
    onFilterChange({ ...filters, dateRange: value });
  };

  const handleSearchChange = (e) => {
    onFilterChange({ ...filters, searchTerm: e?.target?.value });
  };

  const clearFilters = () => {
    onFilterChange({
      status: 'all',
      dateRange: 'all',
      searchTerm: ''
    });
  };

  const hasActiveFilters = filters?.status !== 'all' || filters?.dateRange !== 'all' || filters?.searchTerm;

  return (
    <div className="card">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Icon
              name="Search"
              size={18}
              color="var(--color-muted-foreground)"
              className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
            />
            <Input
              type="text"
              placeholder="Search by rotation number..."
              value={filters?.searchTerm}
              onChange={handleSearchChange}
              className="pl-10"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <Select
            value={filters?.status}
            onChange={handleStatusChange}
            options={statusOptions}
            className="min-w-[140px]"
          />

          <Select
            value={filters?.dateRange}
            onChange={handleDateRangeChange}
            options={dateRangeOptions}
            className="min-w-[140px]"
          />

          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="px-4 py-2 rounded-lg border border-border bg-card hover:bg-card-hover text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2 text-sm font-medium"
            >
              <Icon name="X" size={16} />
              Clear
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterControls;